import { URLS, getUrls } from 'api/config';
import $api from 'api/http';

export default class UserService {
    static async me() {
        return $api.get(getUrls({ name: URLS.me }));
    }
    static async createUsers() {
        return $api.post(getUrls({ name: URLS.create_users }));
    }
    static async createAdmin() {
        return $api.post(getUrls({ name: URLS.create_admin }));
    }
    static async users() {
        return $api.get(getUrls({ name: URLS.users }));
    }
    static async userById(id: string) {
        return $api.get(getUrls({ name: URLS.users_by_id, id }));
    }
    static async updatePassword(data: { password: string; newPassword: string }) {
        return $api.post(getUrls({ name: URLS.update_password }), data);
    }
    static async updateLogin(data: { password: string; email: string }) {
        return $api.post(getUrls({ name: URLS.update_login }), data);
    }
    static async updateById(
        id: string,
        data: {
            firstName: string;
            lastName: string;
        },
    ) {
        return $api.post(getUrls({ name: URLS.update_by_id, id }), data);
    }
}
